import { AccountDeleteWidget } from 'feature/account/account-delete';
import { CLICK, component, demoFile, feature, POPUP, story, variant } from 'system/demo';

demoFile('feature/account/account-delete', {
    designUrl:
        'https://www.figma.com/design/iP7DEaY8SVqQcEGN6Feipj/Basic-Profile-%2B-Privacy-Settings?node-id=1966-5780&p=f&t=MYbBGUW6ZQjY60Ab-0',
});

component('AccountDeleteWidget', AccountDeleteWidget, {}, [
    story('Show Modal', [CLICK('Delete')]),
    story('Delete Profile', [CLICK('Delete'), POPUP(CLICK('Delete'))]),
    story('Cancel', [CLICK('Delete'), POPUP(CLICK('close-modal'))]),
]);

feature('profiledelete', {
    structureKey: 'account',
});
